"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendSMSListTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const option_1 = require("../../../../common/option");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const sms_1 = require("../../../../server/sms");
const action_1 = require("../../../menu/action");
const DSTL007_Detail_1 = require("../DSTL007_Detail");
const SendSMSTitle_1 = require("./SendSMSTitle");
const SendSMSTableStyles = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	overflow: auto;

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.body-item {
		.pink {
			color: var(--color-pink, #f46790);
		}

		.tur {
			color: var(--tur-d, #479da6);
		}
	}

	.bold-tur {
		p {
			color: var(--tur-d, #479da6);
			font-weight: 700;
		}
	}

	.sms-list-001 {
		width: 100%;
		overflow: auto;
	}

	.locked-wrap {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.title-wrap {
		width: 100%;
	}
	.paging {
		margin: 0px;
	}

	.scroll-content {
		overflow: unset;
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.empty_data {
		flex: 1;
	}
	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	gap: 12px;

	.title-wrap {
		display: flex;
		flex-direction: column;
		gap: 12px;
		padding: 12px 20px 12px 20px;
		background: var(--color-silver, #f3f4f8);

		.title-button-wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			.title {
				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
			}
		}
	}

	.sms-list-001 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		padding: 0 20px 20px 20px;

		.body-item {
			display: flex;
			justify-content: flex-start;
			align-items: center;

			p {
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b3-font-size, 12px);
				line-height: 150%;
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
			}

			.button {
				p {
					font-size: var(--b3-font-size, 10px);
					color: var(--color-white, #ffffff);
					width: 30px;
					height: 17px;
					display: flex;
					justify-content: center;
				}
			}

			.bold {
				font-size: 14px;
				font-weight: 700;
			}

			.grey {
				color: var(--color-grey-l, #83868a);
			}
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px 0px 0px 0px;
			padding: 12px 0px 12px 0px;
			gap: 4px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			&:nth-child(1) {
				border: none;
			}
		}

		.open-contents {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px 0px 0px 0px;
		}
	}

	.qna-list-wrap {
		display: flex;
		flex-direction: row;
		gap: 6px;
	}

	.locked-wrap {
		gap: 4px;
		svg {
			min-width: 14px;
		}
	}
	.search-bar-big {
		height: 41px;
	}

	.divider {
		background: var(--color-grey-c, #e6e8ed);
		flex-shrink: 0;
		width: 1px;
		flex: 1;
		position: relative;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	flex: 1;
	gap: 12px;
	min-width: 460px;
	min-height: 100%;
	height: fit-content;


	.sms-list-001 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: 12px 20px 12px 20px;
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-grey, #666666);
			text-align: center;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.body-item {
			display: flex;
			justify-content: flex-start;
			align-items: center;

			p {
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: var(--b3-font-weight, 400);
			}

			.button {
				p {
					font-size: var(--b3-font-size, 12px);
					color: var(--color-white, #ffffff);
					width: 45px;
					height: 21px;
					display: flex;
					justify-content: center;
				}
			}
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;

			padding: 12px 20px 12px 20px;
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}
	}

	.search-bar-big {
		height: 41px;
	}

	.paging {
		gap: 8px;
		button {
			width: 25px;
			height: 25px;
			p {
				min-width: unset;
			}
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	flex: 2;
	gap: 24px;
	min-height: 100%;
	height: fit-content;

	.sms-list-001 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: 6px 28px 6px 28px;
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-grey, #666666);
			text-align: center;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		

		.body-item {
			display: flex;
			justify-content: flex-start;
			align-items: center;

			p {
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b3-font-size, 16px);
				line-height: var(--b3-line-height, 32px);
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
			}

			.file {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 8px;
				overflow: hidden;
				p {
					color: var(--color-grey-w, #b6bac0);
				}
			}

			.button {
				p {
					font-size: var(--b3-font-size, 14px);
					color: var(--color-white, #ffffff);
					width: 49px;
					height: 30px;
					display: flex;
					justify-content: center;
				}
			}
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;

			padding: 12px 28px;
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}
	}
`;
exports.SendSMSListTable = react_1.default.memo(({ selectedId, setSelectedId, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const count = 10; // 페이지당 데이터 수
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [startDate, setStartDate] = (0, react_1.useState)('');
    const [endDate, setEndDate] = (0, react_1.useState)('');
    // 키워드 검색
    const [keyword, setKeyword] = (0, react_1.useState)('');
    // 발송 상태
    const [sendStatus, setSendStatus] = react_1.default.useState('select');
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'live_status', space: 1 },
            ...(isMobile ? [] : [{ title: 'just_type', space: 1 }]),
            { title: 'live_title', space: 5 },
            ...(isMobile ? [] : [{ title: 'sender', space: 1 }]),
            { title: 'sendDate', space: 2 },
        ];
        const tableReadDataKeys = [
            { title: 'status', space: 1 },
            ...(isMobile ? [] : [{ title: 'type', space: 1 }]),
            { title: 'title', space: 5 },
            ...(isMobile ? [] : [{ title: 'sender_name', space: 1 }]),
            { title: 'send_time', space: 2 },
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, [isMobile]);
    (0, react_1.useEffect)(() => {
        if (isMobile) {
            //history에 저장된 항목 초기화 (리스트 페이지일 때만) - 발송 -> 수정으로 이동 시 초기화
            const value = localStorage.getItem('learningManagement_props');
            if (value !== 'undefined') {
                const parsedValue = JSON.parse(value)?.historyItem?.props;
                if (parsedValue?.mobilePage === 'list' || parsedValue?.mobilePage === 'send') {
                    const historyItem = { props: undefined, pageName: 'mobileSend' };
                    historyStore.pushHistory(historyItem);
                }
            }
        }
        APP.eventManager.subscribe('UPDATE_SEND_SMS', refetchList);
        return () => {
            APP.eventManager.unsubscribe('UPDATE_SEND_SMS', refetchList);
        };
    }, []);
    const { data, refetch } = (0, sms_1.useSendSMSList)({
        ...(endDate
            ? {
                send_time_before: endDate
                    ? (0, moment_1.default)(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
                    : undefined,
            }
            : {}),
        ...(startDate
            ? {
                send_time_after: startDate
                    ? (0, moment_1.default)(startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
                    : undefined,
            }
            : {}),
        ...(sendStatus === '' || sendStatus === 'select' ? {} : { status: sendStatus }),
        ...(keyword ? { keyword } : {}),
        offset: page === 0 ? 0 : page * count,
        limit: count,
        orderby: 'send_time DESC',
    });
    const refetchList = (0, throttle_1.default)(() => refetch(), 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        setSelectedId('');
        refetchList();
    }, [startDate, endDate, keyword, sendStatus, page]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / 10) - 1);
                setPage(maxPage);
                return;
            }
            if (found_count > 0) {
                setTestData(items);
                setTotalCount(total_count);
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    const handlerMoreData = (page) => setPage(page);
    const renderTitle = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "title-wrap" },
            react_1.default.createElement(SendSMSTitle_1.SendSMSTitle, { sendStatus: sendStatus, startDate: startDate, endDate: endDate, setSendStatus: setSendStatus, setStartDate: setStartDate, setEndDate: setEndDate, setKeyword: setKeyword })));
    }, []);
    const renderItem = (item, styles, index) => {
        const isSelcted = item.id === selectedId;
        const isSent = item.status === 'created' && (0, moment_1.default)(item.send_time).isBefore((0, moment_1.default)());
        const displayStatus = isSent ? 'sent' : item.status;
        if (isMobile)
            return tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: `${item.id} ${headItem.title}`, className: `body-item ${isSelcted ? 'bold-tur' : ''}` },
                headItem.title === 'status' &&
                    react_1.default.createElement("div", { style: { display: 'flex', gap: 2 } },
                        react_1.default.createElement("p", { className: "overText2" }, t(`sendSMS.${displayStatus}`)),
                        react_1.default.createElement("div", { className: "divider" }),
                        react_1.default.createElement("p", { className: "overText2" }, item.type === "normal" ? "일반" : "치환")),
                headItem.title === 'title' &&
                    react_1.default.createElement("p", { className: "overText2", key: `${item.id} ${headItem.title}`, style: { wordBreak: 'break-all', fontWeight: headItem.title === 'title' ? 700 : 400 } }, item[headItem.title] || item.content.slice(0, 20) + `${item.content.length > 20 ? '...' : ''}`),
                headItem.title === 'send_time' &&
                    react_1.default.createElement("p", { className: "overText2", key: `${item.id} ${headItem.title}`, style: { wordBreak: 'break-all', fontWeight: headItem.title === 'title' ? 700 : 400 } }, (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD, HH:mm')))));
        return tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: `${item.id} ${headItem.title}`, className: `body-item ${isSelcted ? 'bold-tur' : ''}`, style: {
                flex: headItem.space,
                maxWidth: headItem?.maxWidth ? headItem.maxWidth : 'auto',
                ...styles?.bodyItem,
                overflow: 'hidden',
            } }, headItem.title === 'status' ? (react_1.default.createElement("p", { className: "overText2" }, t(`sendSMS.${displayStatus}`))) : headItem.title === 'send_time' ? (react_1.default.createElement("p", { className: "overText2" }, (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD, HH:mm'))) : headItem.title === 'title' ? (react_1.default.createElement("p", { className: "overText2", style: { wordBreak: 'break-all' } }, item[headItem.title] || item.content.slice(0, 20) + `${item.content.length > 20 ? '...' : ''}`)) : headItem.title === 'type' ? (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title] === "normal" ? "일반" : "치환")) : (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title])))));
    };
    const renderMoreItem = () => {
        return (react_1.default.createElement(DSTL007_Detail_1.DSTL007_Detail, { selectedId: selectedId, setSelectedId: setSelectedId }));
    };
    const handlerSelectItem = (item) => {
        const newId = selectedId === item.id ? '' : item.id;
        setSelectedId(newId);
        dispatch((0, action_1.changeMemuProps)({ defaultOpen: newId }));
    };
    const renderEmpty = (0, react_1.useMemo)(() => {
        return react_1.default.createElement(option_1.EmptyTable, { title: 'sendSMS.noData' });
    }, []);
    return (react_1.default.createElement(SendSMSTableStyles, { "$isTablet": isTablet, "$isMobile": isMobile, className: "sms-list-table" },
        react_1.default.createElement(common_1.Table, { className: 'sms-list-001', showIndex: false, showCheckBox: false, isInfinite: false, selectedId: selectedId, padding: false, page: page, showCount: count, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, renderEmpty: testData.length <= 0 && renderEmpty, renderMoreItem: isMobile && renderMoreItem, handlerSelectItem: handlerSelectItem, handlerMoreData: handlerMoreData, forceShowheader: isMobile ? false : true })));
});
